import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import TimePickerInput from '../../TimePickerInput/TimePickerInput';
import RateBuilderErrors from "../RateBuilderErrors";
import NumberInput from "../../NumberInput/NumberInput";
import CurrencyInput from "../../CurrencyInput/CurrencyInput";
import PercentageInput from "../../PercentageInput/PercentageInput";
import FormSelect from "../../Selects/FormSelect"
import SingleSelect from "../../Selects/SingleSelect"
import PropertySelect from "../../Selects/PropertySelect"

class RateBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      dateFormat: DateHelper.rubyToDateJS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateJS(this.props.time_format),
    };

    this.onChange = this.onChange.bind(this)
    this.onChangeAmount = this.onChangeAmount.bind(this)
    this.onChangePercentage = this.onChangePercentage.bind(this)
    this.onChangeCheckInTime = this.onChangeCheckInTime.bind(this)
    this.onChangeCheckOutTime = this.onChangeCheckOutTime.bind(this)
    this.onChangeStartBookingDate = this.onChangeStartBookingDate.bind(this)
    this.onChangeEndBookingDate = this.onChangeEndBookingDate.bind(this)
  };

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <input
                type="text"
                name="code"
                maxLength="12"
                value={this.props.code}
                onChange={this.onChange}
                className={this.renderFieldClasses('code')}
                data-model="Rate"
                data-column="code" />
              {this.renderFieldErrors('code')}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <div>
                <input
                  type="text"
                  name="name"
                  value={this.props.name}
                  onChange={this.onChange}
                  className={this.renderFieldClasses('name')}
                  data-model="Rate"
                  data-column="name" />
                {this.renderFieldErrors('name')}
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('rate_type')} <span className="ss-help help" title={I18n.t('rate_type_helper_text')}></span></label>
              <select name="rate_type" value={this.props.rate_type || ''} className="form-control" onChange={this.onChange}>
                <option value="transient">{I18n.t('transient')}</option>
                <option value="special">{I18n.t('special')}</option>
                <option value="group">{I18n.t('group')}</option>
              </select>
            </div>
            {
              this.props.rate_type === 'special'
              ?
              <div className="form-group">
                <label>{I18n.t('hidden')} <span className="ss-help help" title={I18n.t('hidden_special_rate_helper_text')}></span></label>
                <select name="is_hidden" value={this.props.is_hidden} className="form-control" onChange={this.onChange}>
                  <option value={true}>{I18n.t('yes')}</option>
                  <option value={false}>{I18n.t('no')}</option>
                </select>
              </div>
              :
              null
            }
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <select name="status" value={this.props.status || ''} className="form-control" onChange={this.onChange}>
                <option value="disabled">{I18n.t('Disabled')}</option>
                <option value="enabled">{I18n.t('enabled')}</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('check_in_time_override')} <span className="ss-help help" title={I18n.t('check_in_time_helper_text')}></span></label>
              <TimePickerInput
                format={this.props.time_format}
                onChange={this.onChangeCheckInTime}
                className={this.renderFieldClasses('check_in_time')}
                selectedTime={this.props.check_in_time}
                offsetTime={false}
              />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('check_out_time_override')} <span className="ss-help help" title={I18n.t('check_out_time_helper_text')}></span></label>

              <TimePickerInput
                format={this.props.time_format}
                onChange={this.onChangeCheckOutTime}
                className={this.renderFieldClasses('check_out_time')}
                selectedTime={this.props.check_out_time}
                offsetTime={false}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-2">
            <div className="form-group">
              <label style={{ textTransform: 'capitalize' }}>{I18n.t('min_stay_override')} <span className="ss-help help" title={I18n.t('rate_min_stay_helper_text')}></span></label>
              <NumberInput
                name="minimum_stay"
                className="form-control"
                onChange={this.onChange}
                value={this.props.minimum_stay} />
              {this.props.new_record == true 
              ? <div className="text-center" style={{color: 'rgb(119, 119, 119)', marginTop: '5px'}}>
                  <i>{this.props.default_number_of_nights}</i>
                </div> 
              : null}
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('max_stay')} <span className="ss-help help" title={I18n.t('rate_max_stay_helper_text')}></span></label>
              <NumberInput
                name="maximum_stay"
                className="form-control"
                onChange={this.onChange}
                value={this.props.maximum_stay} />
                
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('min_lead')} <span className="ss-help help" title={I18n.t('rate_min_lead_helper_text')}></span></label>
              <NumberInput
                name="minimum_lead"
                className="form-control"
                onChange={this.onChange}
                value={this.props.minimum_lead} />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('max_lead')} <span className="ss-help help" title={I18n.t('rate_max_lead_helper_text')}></span></label>
              <NumberInput
                name="maximum_lead"
                className="form-control"
                onChange={this.onChange}
                value={this.props.maximum_lead} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('start_booking_date')} <span className="ss-help help" title={I18n.t('rate_start_booking_date_helper_text')}></span></label>
              <DatePickerInput
                selectedDate={this.props.start_booking_date}
                dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                onChange={this.onChangeStartBookingDate}
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('end_booking_date')} <span className="ss-help help" title={I18n.t('rate_end_booking_date_helper_text')}></span></label>
              <DatePickerInput
                selectedDate={this.props.end_booking_date}
                dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                onChange={this.onChangeEndBookingDate}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('short_description')} <span className="ss-help help" title={I18n.t('rate_short_description_helper_text')}></span></label>
              <input
                type="text"
                name="short_description"
                value={this.props.short_description}
                onChange={this.onChange}
                className="form-control" />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('long_description')} <span className="ss-help help" title={I18n.t('long_description_helper_text')}></span></label>
              <textarea
                name="long_description"
                value={this.props.long_description}
                onChange={this.onChange}
                className="form-control"
                rows="5" />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="panel" style={{ marginBottom: 0 }}>
              <div className="panel-body container default-panel">
                {this.renderAmountPercentageForm()}
              </div>
            </div>
          </div>

        </div>
        {/* {
          this.props.duplicate
            ?
          <div className="row">
            <br />
            <div className="col-md-4">
              <label>{I18n.t('duplicate_to_property')}</label>
              <PropertySelect property={this.props.property} onChange={this.props.onChangeProperty} />
            </div>

          </div>
            :
          null

        } */}




      </div>
    );
  };

  renderAmountPercentageForm() {
    if (this.props.read_only) {
      if (this.props.amount) {
        return (
          <div>
            <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0 }}>{I18n.t('standard_rate_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>
            <div>${numeral(this.props.amount / 100).format(this.state.numberFormat)}</div>
          </div>
        )
      } else if (this.props.percentage) {
        return (
          <div>
            <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0 }}>{I18n.t('standard_rate_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>
            <div>{this.props.percentage * 100}%</div>
          </div>
        )
      } else {
        return (
          <div>
            <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0 }}>{I18n.t('standard_rate_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>
            <div><span className="none">{I18n.t('none')}</span></div>
          </div>
        )
      }
    } else {
      return (
        <div>
          <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0 }}>{I18n.t('base_price_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>

          <div className="row">
            <div className="col-md-5">
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>{I18n.t('amount')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
                {/* <div className="input-group input-group-currency maxlength7" style={{ marginLeft: 0, marginRight: 0 }}>
                  <span className="input-group-addon">$</span> */}
                  <CurrencyInput name="amount" onChange={this.onChangeAmount}  value={this.props.amount} className={this.renderFieldClasses('amount')} />
                {/* </div> */}
                {this.renderFieldErrors('amount')}
              </div>
            </div>
            <div className="col-md-2 or-col">
              <div className="input-group input-group-currency maxlength7">{I18n.t('or')}</div>
            </div>
            <div className="col-md-5">
              <div className="form-group percentagxe-form-group">
                <label>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('rate_percentage_helper_text')}></span></label>
                {/* <div className="input-group input-group-currency maxlength7"> */}
                  <PercentageInput name="percentage" onChange={this.onChangePercentage} value={this.props.percentage} className={this.renderFieldClasses('percentage')} />
                  {/* <span className="input-group-addon">%</span> */}
                {/* </div> */}
                {this.renderFieldErrors('percentage')}
              </div>
            </div>
          </div>
        </div>
      );
    };
  };



  renderErrors() {
    var errors = RateBuilderErrors.general(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  };

  /******************
  * Change handlers *
  *******************/

  onChange(event) {
    if (typeof this.props.onChange == 'function') {
      this.props.onChange(event);
    };
  };

  onChangeAmount(amount) {
    if (amount || amount === 0) {
      this.onChange({
        target: {
          name: 'amount',
          value: amount
        }
      });
    };
  };

  onChangePercentage(percentage) {
    if (percentage && percentage != '' || percentage == 0) {
      this.onChange({
        target: {
          name: 'percentage',
          value: percentage
        }
      });
    };
  };

  onChangeStartBookingDate(date) {
    this.onChange({
      target: {
        name: 'start_booking_date',
        value: date
      }
    });
  };

  onChangeEndBookingDate(date) {
    this.onChange({
      target: {
        name: 'end_booking_date',
        value: date
      }
    });
  };

  onChangeCheckInTime(time) {
    this.onChange({
      target: {
        name: 'check_in_time',
        value: time
      }
    });
  };

  onChangeCheckOutTime(time) {
    this.onChange({
      target: {
        name: 'check_out_time',
        value: time
      }
    });
  };

};

export default RateBuilderGeneral
